const FALLBACK_PUBLIC_APP_URL = "https://splitkart.app";
const PRIMARY_PUBLIC_HOST = "splitkart.app";

function normalizePublicOrigin(value: string): string {
  try {
    const parsed = new URL(value);
    if (parsed.hostname.toLowerCase() === `www.${PRIMARY_PUBLIC_HOST}`) {
      parsed.hostname = PRIMARY_PUBLIC_HOST;
    }
    return parsed.origin;
  } catch {
    return FALLBACK_PUBLIC_APP_URL;
  }
}

function getRuntimePublicOrigin(): string {
  if (typeof window === "undefined") return "";

  const { hostname, origin } = window.location;
  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.endsWith(".local");

  if (isLocalhost) return "";
  return normalizePublicOrigin(origin);
}

const rawPublicAppUrl =
  (import.meta.env.VITE_PUBLIC_APP_URL as string | undefined)?.trim() ||
  getRuntimePublicOrigin() ||
  FALLBACK_PUBLIC_APP_URL;

export const PUBLIC_APP_URL = normalizePublicOrigin(rawPublicAppUrl);
export const ACCESS_GATE_ENABLED = import.meta.env.PROD
  ? (import.meta.env.VITE_ACCESS_GATE_ENABLED as string | undefined) === "true"
  : (import.meta.env.VITE_ACCESS_GATE_ENABLED as string | undefined) === "true";

export function buildPublicAppUrl(path = "/"): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${PUBLIC_APP_URL}${normalizedPath}`;
}

export function buildMerchantStoreUrl(storeUrl: string | null | undefined): string | null {
  const rawValue = String(storeUrl || "").trim();
  if (!rawValue) return null;

  const normalizedValue = rawValue.startsWith("//")
    ? `https:${rawValue}`
    : /^https?:\/\//i.test(rawValue)
      ? rawValue
      : `https://${rawValue}`;

  try {
    return new URL(normalizedValue).toString();
  } catch {
    return null;
  }
}
